import Fatality from './Fatality';

export default Fatality;